import type { Shape } from "../types";

/** Unité d'une épaisseur de bordure (`ShapeStyle.borderWidthUnit`) : pixels écran, ou mètres au sol. */
export type BorderWidthUnit = "px" | "m";

/** Zoom de référence haut de l'interpolation des épaisseurs (voir `borderWidthStopsPx`). */
export const BORDER_WIDTH_MAX_ZOOM = 24;

const EARTH_CIRCUMFERENCE_METERS = 40_075_016.686;

function metersPerPixel(zoom: number, latDeg: number): number {
  return (EARTH_CIRCUMFERENCE_METERS * Math.cos((latDeg * Math.PI) / 180)) / (512 * 2 ** zoom);
}

/**
 * Épaisseur en pixels aux zooms 0 et `BORDER_WIDTH_MAX_ZOOM`, à interpoler exponentiellement (base 2)
 * sur le zoom : identiques en pixels, proportionnelles à l'échelle en mètres — l'interpolation est
 * alors exacte, les pixels par mètre doublant à chaque niveau de zoom.
 */
export function borderWidthStopsPx(width: number, unit: BorderWidthUnit, latDeg: number): { atZ0: number; atZMax: number } {
  if (unit === "px") return { atZ0: width, atZMax: width };

  return { atZ0: width / metersPerPixel(0, latDeg), atZMax: width / metersPerPixel(BORDER_WIDTH_MAX_ZOOM, latDeg) };
}

/** Latitude de référence d'une forme pour convertir des mètres en pixels : le milieu de son emprise. */
export function shapeReferenceLatitude(shape: Shape): number {
  const lats = shape.coordinates.map(([, lat]) => lat);
  if (!lats.length) return 0;

  return (Math.min(...lats) + Math.max(...lats)) / 2;
}
